import { Routes } from '@angular/router';
import { RedirecionamentoComponent } from './components';
import { permissoesGuard } from './guards/permissoes/permissoes.guard';

export const routes: Routes = [
  { path: 'index/:token', component: RedirecionamentoComponent },
  {
    path: 'premoplan',
    loadComponent: () => import('./components').then(c => c.HomeComponent),
    data: { permissao: 'acessar_premoplan' },
    canActivate: [permissoesGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./components/mapa/mapa.routes').then(m => m.mapaRoutes)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.routes').then(m => m.dashboardRoutes)
      },
      {
        path: 'turnos',
        loadChildren: () => import('./components/turnos/turnos.routes').then(m => m.turnosRoutes)
      },
      {
        path: 'equipamentos',
        loadChildren: () => import('./components/equipamentos/equipamentos.routes').then(m => m.equipamentosRoutes)
      },
      {
        path: 'frentes',
        loadChildren: () => import('./components/frentes/frentes.routes').then(m => m.frentesRoutes)
      },
      {
        path: 'metas',
        loadChildren: () => import('./components/metas/metas.routes').then(m => m.metasRoutes)
      },
      {
        path: 'operacoes',
        loadChildren: () => import('./components/operacoes/operacoes.routes').then(m => m.operacoesRoutes)
      },
      {
        path: 'apontamentos',
        loadChildren: () => import('./components/apontamentos/apontamentos.routes').then(m => m.apontamentosRoutes)
      },
      {
        path: 'taxas-ideais',
        loadChildren: () => import('./components/taxas-ideais/taxas-ideais.routes').then(m => m.taxasIdeaisRoutes)
      },
      {
        path: 'velocidade-ideal',
        loadChildren: () => import('./components/velocidade-ideal/velocidade-ideal.routes').then(m => m.velocidadeIdealRoutes)
      },
      {
        path: 'informacoes-trator',
        loadChildren: () => import('./components/informacoes-trator/informacoes-trator.routes').then(m => m.informacoesTratorRoutes)
      },
      {
        path: 'agview-connect',
        loadChildren: () => import('./components/agview-connect/agview-connect.routes').then(m => m.agviewConnectRoutes)
      },
      {
        path: 'chat',
        loadChildren: () => import('./components/chat/chat.routes').then(m => m.chatRoutes)
      },
      {
        path: 'kanban',
        loadChildren: () => import('./components/kanban-operacoes/kanban-operacoes.routes').then(m => m.kanbanOperacoesRoutes)
      },
      {
        path: 'insumos',
        loadChildren: () => import('./components/insumos/insumos.routes').then(m => m.insumoRoutes)
      },
    ]
  },
  { path: '', redirectTo: 'premoplan', pathMatch: 'full' },
  { path: '**', redirectTo: 'premoplan' }
];
